import { render, staticRenderFns } from "./AffiliateCommissionArchivePanel.vue?vue&type=template&id=d58da084&scoped=true"
import script from "./AffiliateCommissionArchivePanel.vue?vue&type=script&lang=js"
export * from "./AffiliateCommissionArchivePanel.vue?vue&type=script&lang=js"
import style0 from "./AffiliateCommissionArchivePanel.vue?vue&type=style&index=0&id=d58da084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58da084",
  null
  
)

export default component.exports